// import { RegisterContainer } from "../../containers/RegisterSystem/RegisterContainer";
import { ConsiderProfileDetailContainer } from "../../containers/RegisterSystem/ConsiderProfileDetailContainer"

export function ConsiderProfileDetailPage() {
    return (
        <ConsiderProfileDetailContainer />
    )
}